import Image from "next/image"
import { useTypedSelector } from "store"
import styled from "styled-components"
type ImageContainerTypes = {
  src: string
}

const StyledImageContainer = styled.div<{ $collapseOpen: boolean }>`
  width: 100%;
  position: relative;
  height: 150px;
  ${(p) => p.theme.breakpoints.up("md")} {
    height: 270px;
    ${(p) => p.$collapseOpen && "margin-top: 63px"};
  }
  img {
    object-fit: cover;
  }
`

const ImageContainer = ({ src }: ImageContainerTypes) => {
  const { collapseOpen } = useTypedSelector((state) => state.collapseLayout)

  return (
    <StyledImageContainer $collapseOpen={collapseOpen}>
      <Image
        src={src}
        priority
        alt="page-cover-img"
        role="presentation"
        aria-hidden="true"
        fill
        sizes="100vw" />
      {/* <StyledImage
        src={src}
        alt="page-cover-img"
        role="presentation"
        aria-hidden="true"
        loading="lazy"
      /> */}
    </StyledImageContainer>
  );
}

export default ImageContainer
